function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import '../../../../service/search/searchservice';
import { showResultsPopup } from './SearchResultsPopup';
import { showOptionsPopup } from './SearchOptionsPopup';
import { Messaging, StateHandler, controllerMixin } from 'oskari-ui/util';
import { SearchResultHelper } from './SearchResultHelper';

// sort channel in alphabetical order but have defaults on top
var channelSortFunction = function channelSortFunction(a, b) {
  var _a$locale2, _b$locale2;
  if (a.isDefault && b.isDefault) {
    var _a$locale, _b$locale;
    return Oskari.util.naturalSort((_a$locale = a.locale) === null || _a$locale === void 0 ? void 0 : _a$locale.name, (_b$locale = b.locale) === null || _b$locale === void 0 ? void 0 : _b$locale.name);
  } else if (a.isDefault) {
    return -1;
  } else if (b.isDefault) {
    return 1;
  }
  return Oskari.util.naturalSort((_a$locale2 = a.locale) === null || _a$locale2 === void 0 ? void 0 : _a$locale2.name, (_b$locale2 = b.locale) === null || _b$locale2 === void 0 ? void 0 : _b$locale2.name);
};

/**
 * Generate a runtime id for non-wfs search channel results
 * @param {SearchResultObject} result
 * @returns String to use as id
 */
var getIdForResult = function getIdForResult(result) {
  if (result.id) {
    return result.id;
  }
  return result.name + result.lon + result.lat;
};
// generate id and simple geometry
var processResultLocations = function processResultLocations(results) {
  if (!results) {
    return;
  }
  var _results$locations = results.locations,
    locations = _results$locations === void 0 ? [] : _results$locations;
  locations.forEach(function (loc) {
    if (!loc.id) {
      loc.id = getIdForResult(loc);
    }
    // WFS search channels have GEOMETRY attached as WKT. For others we can generate a simple point geometry.
    if (!loc.GEOMETRY) {
      loc.GEOMETRY = "POINT (".concat(loc.lon, " ").concat(loc.lat, ")");
    }
  });
  return results;
};
var SearchHandler = /*#__PURE__*/function (_StateHandler) {
  function SearchHandler(plugin) {
    var _plugin$getConfig, _plugin$getConfig2, _plugin$getConfig3;
    var _this;
    _classCallCheck(this, SearchHandler);
    _this = _callSuper(this, SearchHandler);
    _this.plugin = plugin;
    _this.setState({
      minimized: false,
      loading: [],
      hasOptions: false,
      selectedChannels: [],
      featuresOnMap: [],
      suggestions: []
    });
    // ['selected', 'name', 'region', 'type'] or null/empty array for all
    _this.columns = plugin.getConfig().columns || ['name', 'region', 'type'];
    _this._popupControlsResult = null;
    _this.eventHandlers = _this.createEventHandlers();
    _this.service = Oskari.clazz.create('Oskari.service.search.SearchService', plugin.getSandbox(), (_plugin$getConfig = plugin.getConfig()) === null || _plugin$getConfig === void 0 ? void 0 : _plugin$getConfig.url);
    _this.resultHelper = new SearchResultHelper(plugin.getSandbox(), (_plugin$getConfig2 = plugin.getConfig()) === null || _plugin$getConfig2 === void 0 ? void 0 : _plugin$getConfig2.useInfobox);
    // options needs to be enabled explicitly
    _this.allowOptions = !!((_plugin$getConfig3 = plugin.getConfig()) !== null && _plugin$getConfig3 !== void 0 && _plugin$getConfig3.allowOptions);
    _this.fetchChannels();
    return _this;
  }
  _inherits(SearchHandler, _StateHandler);
  return _createClass(SearchHandler, [{
    key: "teardown",
    value: function teardown() {
      this.clearResultPopup();
      this.clearOptionsPopup();
    }
  }, {
    key: "clearResultPopup",
    value: function clearResultPopup() {
      this.resultHelper.removeMarker();
      this.resultHelper.removeResultFromMap();
      if (this._popupControlsResult) {
        this._popupControlsResult.close();
      }
      this._popupControlsResult = null;
      this.updateState({
        results: null
      });
    }
  }, {
    key: "getMsg",
    value: function getMsg(key, args) {
      return Oskari.getMsg('MapModule', 'plugin.SearchPlugin.' + key, args);
    }
  }, {
    key: "updateResultsPopup",
    value: function updateResultsPopup() {
      var _this2 = this;
      var _this$getState = this.getState(),
        _this$getState$result = _this$getState.results,
        results = _this$getState$result === void 0 ? {} : _this$getState$result,
        loading = _this$getState.loading,
        channels = _this$getState.channels,
        featuresOnMap = _this$getState.featuresOnMap;
      if (!loading.length) {
        // we have all results
        // check if we didn't find anything OR if we found just one
        var currentChannels = Object.keys(results).filter(function (chan) {
          return !!results[chan];
        });
        if (!currentChannels.length) {
          // previous search result cleared
          Messaging.error(this.getMsg('noresults'));
          this.clearResultPopup();
          return;
        }
        var combined = currentChannels.reduce(function (accumulator, currentValue) {
          var channelResults = results[currentValue];
          if (!channelResults) {
            return accumulator;
          }
          accumulator.push.apply(accumulator, _toConsumableArray(channelResults.locations));
          return accumulator;
        }, []);
        if (combined.length === 0) {
          Messaging.error(this.getMsg('noresults'));
          this.clearResultPopup();
          return;
        } else if (combined.length === 1) {
          // only one result, show it immediately
          this.resultClicked(combined[0]);
          return;
        }
      }
      if (this._popupControlsResult) {
        this._popupControlsResult.update(results, channels, featuresOnMap);
        return;
      }
      this._popupControlsResult = showResultsPopup(results, channels, featuresOnMap, function (result, isToggle) {
        return _this2.resultClicked(result, isToggle);
      }, function () {
        return _this2.clearResultPopup();
      }, this.plugin.getLocation(), this.columns);
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'SearchPluginHandler';
    }
  }, {
    key: "getSandbox",
    value: function getSandbox() {
      return this.plugin.getSandbox();
    }
  }, {
    key: "setQuery",
    value: function setQuery(query) {
      var _this3 = this;
      this.updateState({
        query: query,
        suggestions: []
      });
      var _this$getState2 = this.getState(),
        selectedChannels = _this$getState2.selectedChannels;
      if (query.length > 2) {
        this.service.doAutocompleteSearch(query, function (result) {
          _this3.updateState({
            suggestions: result.methods
          });
        }, selectedChannels.join(','));
      }
    }

    /**
     * Uses SearchService to make the actual search and calls  #_showResults
     */
  }, {
    key: "doSearch",
    value: function doSearch(autocompleteWord) {
      var _this4 = this;
      var _this$getState3 = this.getState(),
        loading = _this$getState3.loading,
        _this$getState3$query = _this$getState3.query,
        query = _this$getState3$query === void 0 ? '' : _this$getState3$query,
        _this$getState3$selec = _this$getState3.selectedChannels,
        selectedChannels = _this$getState3$selec === void 0 ? [] : _this$getState3$selec;
      if (typeof autocompleteWord === 'string') {
        query = autocompleteWord;
      }
      if (loading.length || query.length === 0) {
        return;
      }
      this.clearResultPopup();
      var currentChannels = _toConsumableArray(new Set(loading.concat(selectedChannels)));
      this.updateState({
        query: query,
        loading: currentChannels,
        suggestions: []
      });
      currentChannels.forEach(function (channel) {
        return _this4.triggerSearchForChannel(channel, query);
      });
    }
  }, {
    key: "triggerSearchForChannel",
    value: function triggerSearchForChannel(channel, query) {
      var _this5 = this;
      var updateResults = function updateResults(results) {
        var _this5$getState = _this5.getState(),
          _this5$getState$resul = _this5$getState.results,
          prevResults = _this5$getState$resul === void 0 ? {} : _this5$getState$resul,
          loading = _this5$getState.loading;
        var stateUpdate = {
          loading: results ? loading.filter(function (item) {
            return item !== channel;
          }) : loading,
          results: _objectSpread({}, prevResults)
        };
        if (!results) {
          delete stateUpdate.results[channel];
        } else if (_this5.allowOptions || results.totalCount > 0) {
          // only pass channel results if:
          // - the user has option to select channels OR
          // - the result has hits
          stateUpdate.results[channel] = processResultLocations(results);
        }
        _this5.updateState(stateUpdate);
        _this5.updateResultsPopup();
      };
      // clear previous results
      updateResults();
      this.service.doSearch(query, function (results) {
        updateResults(results);
      }, function () {
        // on error
        updateResults();
      }, undefined, channel);
    }
  }, {
    key: "resultClicked",
    value: function resultClicked(result, isToggled) {
      if (typeof isToggled === 'boolean') {
        var _this$getState4 = this.getState(),
          featuresOnMap = _this$getState4.featuresOnMap;
        if (isToggled) {
          // add to map
          featuresOnMap.push(result);
          this.updateState({
            featuresOnMap: featuresOnMap
          });
          this.resultHelper.showResultOnMap(result);
        } else {
          // remove from map
          this.updateState({
            featuresOnMap: featuresOnMap.filter(function (item) {
              return item.id !== result.id;
            })
          });
          this.resultHelper.removeResultFromMap(result);
        }
        this.updateResultsPopup();
        return;
      }
      var zoom = result.zoomLevel;
      if (result.zoomScale) {
        zoom = {
          scale: result.zoomScale
        };
      }
      this.getSandbox().postRequestByName('MapMoveRequest', [result.lon, result.lat, zoom]);
      this.resultHelper.setMarker(result);
    }

    /** Restore from minimized state */
  }, {
    key: "requestSearchUI",
    value: function requestSearchUI() {
      this.updateState({
        minimized: false
      });
    }
  }, {
    key: "createEventHandlers",
    value: function createEventHandlers() {
      var _this6 = this;
      var handlers = {
        /** Minimize search bar on map click */
        'MapClickedEvent': function MapClickedEvent() {
          _this6.updateState({
            minimized: true
          });
        }
      };
      var sandbox = this.getSandbox();
      Object.getOwnPropertyNames(handlers).forEach(function (p) {
        return sandbox.registerForEventByName(_this6, p);
      });
      return handlers;
    }
  }, {
    key: "onEvent",
    value: function onEvent(e) {
      var handler = this.eventHandlers[e.getName()];
      if (!handler) {
        return;
      }
      return handler.apply(this, [e]);
    }
  }, {
    key: "toggleOptionsPopup",
    value: function toggleOptionsPopup() {
      var _this7 = this;
      if (this._popupControlsOptions) {
        this.clearOptionsPopup();
        return;
      }
      var title = this.getMsg('options.title');
      var controller = this.getController();
      this._popupControlsOptions = showOptionsPopup(title, this.getState(), controller, function () {
        return _this7.clearOptionsPopup();
      }, this.plugin.getLocation());
      // TODO: if the user can select search channels for the query etc
      // related to state.hasOptions: false
      // hasOptions is always false for now since this has not been implemented yet
    }
  }, {
    key: "fetchChannels",
    value: function fetchChannels() {
      var _this8 = this;
      fetch(Oskari.urls.getRoute('SearchOptions')).then(function (response) {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      }).then(function (json) {
        var channels = json.channels;
        if (!channels) {
          throw Error('Unexpected response for search channels');
        }
        var sortedChannels = channels.sort(channelSortFunction);
        // we will change the value of selectedChannels when state changes to keep track if we should update the options popup
        var selectedChannels = channels.filter(function (c) {
          return c.isDefault;
        }).map(function (c) {
          return c.id;
        });
        _this8.updateState({
          channels: sortedChannels,
          hasOptions: _this8.allowOptions && channels.length > 1,
          defaultChannels: _toConsumableArray(selectedChannels),
          selectedChannels: _toConsumableArray(selectedChannels)
        });
        _this8.addStateListener(function (state) {
          if (!_this8._popupControlsOptions) {
            // popup not open
            return;
          }
          if (selectedChannels.length !== state.selectedChannels.length) {
            // selected channels changed -> trigger popup update
            _this8._popupControlsOptions.update(state);
            // make a copy to compare on next update
            selectedChannels = _toConsumableArray(state.selectedChannels);
          }
        });
      }).catch(function (error) {
        throw Error(error);
      });
    }
  }, {
    key: "setChannelEnabled",
    value: function setChannelEnabled(channelId, enabled) {
      var _this$getState5 = this.getState(),
        selectedChannels = _this$getState5.selectedChannels;
      if (enabled) {
        selectedChannels.push(channelId);
      } else {
        selectedChannels = selectedChannels.filter(function (id) {
          return id !== channelId;
        });
      }
      this.clearResultPopup();
      this.updateState({
        selectedChannels: selectedChannels
      });
    }
  }, {
    key: "clearOptionsPopup",
    value: function clearOptionsPopup() {
      if (this._popupControlsOptions) {
        this._popupControlsOptions.close();
      }
      this._popupControlsOptions = null;
    }
  }]);
}(StateHandler);
;
var wrapped = controllerMixin(SearchHandler, ['resultClicked', 'requestSearchUI', 'doSearch', 'setQuery', 'toggleOptionsPopup', 'setChannelEnabled']);
export { wrapped as SearchHandler };